import {useCartItemResource} from "./useCartItemResource";
import {GPAWebDataTypesResourceType} from "../../api/openApi/cartService";
import {DesignServiceModel} from "../../models/domain/designServiceModel";
import {useOffCanvasDesignService} from "./useOffCanvasDesignService";

/**
 * Returns the design service for the current cart item
 * @returns {DesignServiceModel | undefined}
 */
export const useCartItemDesignService = (): DesignServiceModel | undefined => {
   // Pull the design service currently apply to the cart item
    const {resource: cartDesignService} = useCartItemResource(GPAWebDataTypesResourceType.DesignerService)
    // Pull all design services for this product from the off canvas product query
    const {productDesignService} = useOffCanvasDesignService(cartDesignService?.resourceId)
    // Return the design service model, using the price from the cart item design service, or the price from the product design service
    return productDesignService ? new DesignServiceModel({
        price: cartDesignService?.price ?? productDesignService.price,
        title: productDesignService.title,
        id: productDesignService.id,
        type: productDesignService.type,
        name: productDesignService.name
    }) : undefined;
}